import component from "./CheckIn";

export default component;
